<div *ngIf="!!message" class="trade-notification alert alert-warning alert-dismissible fade show" role="status">
    <span class="fas fa-info-circle" aria-hidden="true"></span>
    <span>{{message}}</span>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>